const createDefaultOrigin = () => {
    if (!window || !window.location)
        return undefined;
    const topic = window.location.host.replace("www.", "");
    const channel = "Web";
    return {
        topic,
        channel,
    };
};
const createDefaultConfig = () => {
    if (process.env.WAYKE_ECOM_API_ADDRESS) {
        return {
            api: {
                address: process.env.WAYKE_ECOM_API_ADDRESS,
            },
            origin: createDefaultOrigin(),
        };
    }
    return undefined;
};
class Configuration {
    constructor() {
        this.config = createDefaultConfig();
    }
    static current() {
        if (Configuration.instance) {
            return Configuration.instance;
        }
        const instance = new Configuration();
        if (!instance.config) {
            throw Configuration.notBoundError;
        }
        Configuration.instance = instance;
        return Configuration.instance;
    }
    static bind(newConfig) {
        Configuration.instance = new Configuration();
        Configuration.instance.config = {
            api: {
                address: newConfig.api.address,
            },
            origin: newConfig.origin
                ? {
                    topic: newConfig.origin.topic,
                    channel: newConfig.origin.channel,
                }
                : createDefaultOrigin(),
            bankIdThumbprint: newConfig.bankIdThumbprint,
        };
        return Configuration.instance;
    }
    static destroy() {
        Configuration.instance = undefined;
    }
    getApiAddress() {
        if (!this.config) {
            throw Configuration.notBoundError;
        }
        return this.config.api.address;
    }
    getOrigin() {
        if (!this.config) {
            throw Configuration.notBoundError;
        }
        return this.config.origin;
    }
    useBankIdThumbprint() {
        if (!this.config) {
            throw Configuration.notBoundError;
        }
        return !!this.config.bankIdThumbprint;
    }
    getBankIdThumbprint() {
        if (!this.config) {
            throw Configuration.notBoundError;
        }
        return this.config.bankIdThumbprint;
    }
}
Configuration.instance = undefined;
Configuration.notBoundError = new Error("Configuration not bound yet");
export default Configuration;
